import(/* webpackMode: "eager" */ "/mnt/data/opt/node/penzu-next/app/css/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/data/opt/node/penzu-next/app/treatments-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/data/opt/node/penzu-next/components/auth/auth-completion-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/data/opt/node/penzu-next/components/bugsnag-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/data/opt/node/penzu-next/components/modal-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingProvider"] */ "/mnt/data/opt/node/penzu-next/components/pricing-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/data/opt/node/penzu-next/components/tracking-provider.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/data/opt/node/penzu-next/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/mnt/data/opt/node/penzu-next/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/mnt/data/opt/node/penzu-next/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Merriweather\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-merriweather\",\"weight\":[\"300\",\"400\",\"700\",\"900\"],\"display\":\"swap\",\"fallback\":[\"Tofu\",\"serif\"]}],\"variableName\":\"merriweather\"}");
